export enum MLMonitoringPage {
    TRAINING = 'ml-training-monitoring',
    SEGMENTATION = 'ml-segmentation-monitoring',
    APPLICATIONS = 'applications-monitoring',
    DATASETS = 'datasets-monitoring',
}
